require('fslightbox');

export default class FsLightboxInitilaizer {
	items: NodeListOf<HTMLElement> | null = null;

	constructor(selectors: NodeListOf<HTMLElement> | string) {
		if (typeof selectors === "string") {
			this.items = document.querySelectorAll(selectors);
		}
		else if (selectors instanceof NodeList) {
			this.items = selectors;
		}

		if (this.items && this.items.length > 0) {
			this.items.forEach((item) => {
				let gallery = item.getAttribute('rel') ?? '';
				item.setAttribute('data-fslightbox', gallery);
			});

			this.update();
		}
	}

	update(): void {
		// @ts-ignore
		refreshFsLightbox();
	}
}
